import { useOktaAuth } from "@okta/okta-react";

const useAuthAccessToken = () => {
  const { oktaAuth } = useOktaAuth();
  return oktaAuth.getAccessToken();
};

export default useAuthAccessToken;
